module.exports = __webpack_public_path__ + "static/media/ST3-BG2.bc383219.jpg";